import React from 'react';
// @ts-ignore
import { control } from 'react-validation';
import classNames from 'classnames';

type TInput = {
    error: string;
    className: string;
    errorClassName: string;
    containerClassName: string;
    ref: () => void;
    isChanged: boolean;
    isUsed: boolean;
};

function Input({
    error,
    className,
    errorClassName,
    containerClassName,
    ref,
    isChanged,
    isUsed,
    ...props
}: TInput) {
    const fieldHasChangedWithError = error && Object.prototype.hasOwnProperty.call(props, 'isChanged');

    const inputClass = classNames({
        [className]: true,
        [errorClassName]: fieldHasChangedWithError,
    });

    return (
        <div className={containerClassName}>
            <input {...props} ref={ref} className={inputClass} />
            <span className="form-error">{isChanged && isUsed && error}</span>
        </div>
    );
}

export const ValidationInput = control(Input);
